module.exports = __webpack_public_path__ + "static/media/6.e6bb8d3c.jpg";